import inputWithOptionsDriverFactory from '../InputWithOptions/InputWithOptions.driver';
import deprecationTestkitLog from '../utils/deprecationTestkitLog';

const dropdownDriverFactory = args => {
  deprecationTestkitLog(
    'dropdownTestkitFactory legacy testkit is deprecated and will be removed in next major release. Please use the DropdownTestkit unidriver testkit instead.',
  );
  return inputWithOptionsDriverFactory(args);
};

export default dropdownDriverFactory;
